import moment from "moment"
import { getDisplayImage } from "util/CommonUtils"

export const createCsvUtil = (data) => {
  if (!data || data.length === 0) {
    return ''
  }
  let csvData = []
  const returnString = [
    'Parent TCIN,Components (Component Quantity),Name,Kit Type,MVT,Department,Class,Vendor Id,Vendor Name,Brand,Launch date',
  ]
  csvData = returnString
  csvData = createCsv(data, csvData)

  return csvData.join('\n')
}

export const createCsv = (data, csvData = []) => {
  data.forEach((item) => {
    let csvString = createSingleSampleCSV(item, csvData)
    csvString = csvString.replace(/undefined/g, '')
    csvString = csvString.replace(/null/g, '')
    csvData.push(csvString)
  })
  return csvData
}

export const createSingleSampleCSV = (item) => {
  const toTextCell = (val) => `"\t${val ?? ''}"`
  const childTcinsCell = (() => {
    const qtyMap = item.childTcinQtyMap
    if (qtyMap && Object.keys(qtyMap).length > 0) {
      const formatted = Object.entries(qtyMap)
        .map(([tcin, qty]) => `${tcin}(${qty})`)
        .join('\n')
      return `"\t${formatted}"`
    }
    return toTextCell(item.childTcins)
  })()

return (
    toTextCell(item.vbParentTcin) +
    ',' +
    childTcinsCell +
    ',"' +
    (item.vbName ?? '') +
    '",' +
    (item.kitType ?? '') +
    ',' +
    (item.mvt ?? '') +
    ',' +
    (item.department ?? '') +
    ',' +
    (item.class ?? '') +
    ',' +
    (item.vendorId ?? '') +
    ',"' +
    (item.vendorName ?? '') +
    '","' +
    (item.brand ?? '') +
    '",' +
    moment(item.launchDate ?? '').format('MM/DD/YYYY')
  )

}
